import GROW2529_ACTIONS from '~app/pages/Pricing/experiments/grow_2529_forms/actions';
import GROW2792_ACTIONS from '~app/pages/Pricing/experiments/grow_2792_pnp_refresh_v1/actions';

export enum PACKAGE_ACTIONS {
  SWITCH_PACKAGES = 'SWITCH_PACKAGES',
  UPDATE_PACKAGES = 'UPDATE_PACKAGES',
  UPDATE_PACKAGES_TO_DISPLAY = 'UPDATE_PACKAGES_TO_DISPLAY',
}

const ACTIONS = { ...PACKAGE_ACTIONS, ...GROW2529_ACTIONS, ...GROW2792_ACTIONS };

export default ACTIONS;
